import styled from 'styled-components';
import {Paper} from '@mui/material';
import {COLORS} from '../../../../constants/colors';

interface BookStatisticsWrapperProps {
  isMobile: boolean;
}

export const BookStatisticsWrapper = styled.div<BookStatisticsWrapperProps>`
  padding: ${(props) => (props.isMobile ? '10px' : '20px')};
  box-sizing: border-box;
  border-radius: 12px !important;
  background-color: ${COLORS.urbanBlack};
  margin: 20px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  color: ${COLORS.white};
  font-family: 'Montserrat', sans-serif !important;
`;

export const BookStatisticsTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  margin-left: 30px;
`;

export const StatCard = styled(Paper)`
  padding: 20px;
  height: 100%;
  border-radius: 12px !important;
  transition: transform 0.2s ease-in-out;
  background-color: ${COLORS.urbanBlack};
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.1);
`;

export const BookItem = styled.div`
  margin-bottom: 16px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 8px;
  transition: background 0.2s ease;

  &:last-child {
    margin-bottom: 0;
  }
`;
